module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/zh-hant_hokkaido-1f440c1f8b74d172048a03c4fbaa997d.jpg";